<template>
  <HomeWidgetSmall
    :actionButtonHandler="navigateToNewUsers"
    :hasError="hasError"
    :isLoading="isLoading"
    :metric="totalCount"
    :widgetType="newUsers"
  />
</template>

<script>
import {
  ItemTypeConsts,
  ItemTypeRoutes,
} from 'client/util/Constants';
import {
  eventLocations,
  eventProperties,
} from 'client/GrowthEngineering/utilities/GrowthConstants';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import HomeWidgetConsts from 'client/HomePageV2/constants/HomeWidgetConsts';
import HomeWidgetSmall from 'client/HomePageV2/widgets/HomeWidgetSmall.vue';
import SystemUserApi from 'client/api/v2/SystemUserApi';
import SystemUserFilters from 'client/components/ItemTable/CollectionFilterComponents/constants/SystemUserFilters';
import Util from 'client/util/Util';

const { newUsers } = HomeWidgetConsts.widgetTypes;

const {
  description,
  location,
  section,
  toUrl,
  text: textEventProp,
} = eventProperties;
const {
  homePage,
} = eventLocations;

export default {
  name: 'NewUsersWidget',

  components: {
    HomeWidgetSmall,
  },

  viewAllRoute: ItemTypeRoutes[ItemTypeConsts.viewNewUsers],

  data: () => ({
    hasError: false,
    isLoading: true,
    totalCount: 0,
    newUsers,
  }),

  computed: {
    newUserFilter() {
      const date = new Date();
      date.setDate(date.getDate() - 7);
      return SystemUserFilters.created(date);
    },
  },

  created() {
    this.handleNewUser();
  },

  methods: {
    handleNewUser() {
      return SystemUserApi.fetch(null, 3, null, null, null, [this.newUserFilter])
        .then(({ totalCount }) => {
          this.totalCount = totalCount;
        })
        .catch(() => {
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    navigateToNewUsers() {
      EventHelper.triggerWidgetClicked({
        [description]: 'New Users Widget - Home Page',
        [location]: homePage,
        [section]: 'Home Widgets',
        [toUrl]: this.$options.viewAllRoute,
        [textEventProp]: 'New Users Widget',
      });
      Util.redirect(this.$options.viewAllRoute);
    },
  },
};
</script>
